import { render, staticRenderFns } from "./BuilderForms.vue?vue&type=template&id=b69aa3aa&scoped=true"
import script from "./BuilderForms.vue?vue&type=script&lang=js"
export * from "./BuilderForms.vue?vue&type=script&lang=js"
import style0 from "./BuilderForms.vue?vue&type=style&index=0&id=b69aa3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69aa3aa",
  null
  
)

export default component.exports